var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[(_vm.view == 'home')?_c('HomeVue',{on:{"setView":_vm.setView}}):_vm._e()],1),(_vm.view == 'home')?_c('FooterVue',{attrs:{"view":_vm.view},on:{"setView":_vm.setView}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }